import axios from "./productInstance";

const getBundleItems = async (bundleId: string) => {
    try {
        const response = await axios.get(`/bundles/${bundleId}`);
        return response.data;
    } catch (error: any) {
        console.error("Error getting bundle items:", error?.response?.data || error.message);
        throw new Error("Error getting bundle items");
    }
}

export default getBundleItems;